import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content" };
const _hoisted_2 = {
    "no-gutters": "",
    class: "my-4 d-flex align-center justify-end"
};
import { reactive, ref, } from 'vue';
import { setErrorMessageData } from '@/utils';
import createWorkerFormRules from '@/form/form-rules/workerManangement';
import { routeName } from '@/constants/routeName';
import { i18n } from '@/locales';
import { BusinessError, errorCode } from '@/error';
import { useRouter } from 'vue-router';
import { createWorkerFormData } from '@/form/form-data/createWorkerFormData';
import { alertActionType } from '@/vuex-store/alert/actions';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { objDeepCompare } from '@/utils/object';
import vuexStore from '@/vuex-store';
import { DOCUMENT_SUBMITTED } from '@/constants/convictionStatus';
import WorkInfo from './WorkInfo.vue';
import PrivateInfo from './PrivateInfo.vue';
import DeliverySetting from './DeliverySetting.vue';
const lc = 'views.worker_management.';
const formRulesLc = 'form_rules.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const router = useRouter();
        const formRules = createWorkerFormRules(formRulesLc);
        const formRef = ref(null);
        const formValid = ref(false);
        const createdFormData = createWorkerFormData();
        const createdOriginFormData = createWorkerFormData();
        const formData = reactive(createdFormData);
        const originFormData = reactive(createdOriginFormData);
        const createErrorMessageData = () => ({
            hubEmployeeNumberExistence: '',
            phoneExistence: '',
        });
        const initErrorMessageData = createErrorMessageData();
        const errorMessageData = reactive(initErrorMessageData);
        const setFormData = (key, value) => {
            const splited = key.split('.');
            const [first, second,] = splited;
            if (splited.length === 1) {
                formData[first] = value;
                return;
            }
            formData[first][second] = value;
        };
        const _validateFormWithErrorMessage = (errorMessages) => {
            const isErrorMessageExist = Object.values(errorMessages)
                .some((message) => !!message);
            if (isErrorMessageExist) {
                return false;
            }
            return formRef.value.validate();
        };
        const goToMainPage = () => {
            router.push({
                name: routeName.WORKER_MANAGEMENT,
            });
        };
        // TODO formData 트랜스폼 레이어 필요
        const convertSubmitDataToPayload = (list) => list.reduce((acc, [key, value,]) => {
            if (value === '') {
                return acc;
            }
            if (key === 'workerRegDate') {
                acc[key] = value.replace(/-/g, '');
                return acc;
            }
            if (key === 'workTime') {
                const { on, off, } = value;
                acc[key] = on.replace(':', '') + off.replace(':', '');
                return acc;
            }
            if (key === 'addressFormData') {
                const formattedAddress = value.formattedAddressBasedOfLi();
                if (formattedAddress !== '-') {
                    acc.homeAddress = formattedAddress;
                    return acc;
                }
            }
            acc[key] = value;
            return acc;
        }, {});
        const _onSubmit = async (submitData) => {
            try {
                // 서버에 빈값('')으로 요청 시 주민번호 에러가 발생해 초기값 null로 설정하기
                const submitDataList = Object.entries(submitData);
                const payload = convertSubmitDataToPayload(submitDataList);
                const response = await vuexStore.dispatch('workerManagement/workerCreate/postWorker', payload);
                if (!response.isSuccess) {
                    // res status 200이나 라이더 등록이 불가한 경우
                    if (response.reason || response.message) {
                        vuexStore.dispatch(snackbarActionType.showError, {
                            message: errorCode[response.reason] ?? response.message,
                        });
                        return;
                    }
                    // 네트워크, 서버 등 알 수 없는 에러의 경우
                    vuexStore.dispatch(snackbarActionType.showError, {
                        message: errorCode[response.reason] ?? response.message,
                    });
                    return;
                }
                vuexStore.dispatch(snackbarActionType.showSuccess, {
                    message: i18n.t(`${lc}create_worker_info_success`),
                });
                goToMainPage();
            }
            catch (error) {
                if (error instanceof BusinessError) {
                    vuexStore.dispatch(snackbarActionType.showError, error.message);
                    return;
                }
                vuexStore.dispatch(snackbarActionType.showError, {
                    message: i18n.t('common.failure'),
                });
            }
        };
        /**
         * 전송 클릭 핸들러
         */
        const handleSubmitForm = async () => {
            const valid = _validateFormWithErrorMessage(errorMessageData);
            if (!valid) {
                // fail
                return vuexStore.dispatch(snackbarActionType.showInfo, {
                    message: i18n.t('common.form_validation_error'),
                });
            }
            // 미해당이 아니면 팝업 출력
            if (formData.convictionStatus !== DOCUMENT_SUBMITTED.key) {
                const isConfirmOk = await vuexStore.dispatch(alertActionType.confirm, {
                    headerTitle: '결격여부 확인',
                    bodyContent: '결격여부가 미제출 또는 해당일 경우 등록은 가능하나 수행이 불가합니다. 등록하시겠습니까?',
                    btnConfig: [
                        {
                            text: 'cancel',
                            cssClass: 'outlined info',
                        },
                        {
                            text: 'ok',
                            cssClass: 'danger',
                        },
                    ],
                });
                if (!isConfirmOk) {
                    return false;
                }
            }
            // success
            return _onSubmit(formData);
        };
        /**
         * 취소 클릭 핸들러
         */
        const handleClickCancelForm = async () => {
            const { 
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            workerCashAutoDeductGroupId: originWorkerCashAutoDeductGroupId, 
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            workerDeliveryFeeGroupId: originWorkerDeliveryFeeGroupId, 
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            workerPenaltyGroupId: originWorkerPenaltyGroupId, ...restOriginData } = originFormData;
            const { 
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            workerCashAutoDeductGroupId, 
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            workerDeliveryFeeGroupId, 
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            workerPenaltyGroupId, ...restFormData } = formData;
            const isSameData = objDeepCompare(restOriginData, restFormData);
            if (isSameData) {
                goToMainPage();
                return;
            }
            const isConfirmOk = await vuexStore.dispatch(alertActionType.confirm, {
                headerTitle: `${i18n.t(`${lc}registration`)} ${i18n.t('common.cancel')}`,
                bodyContent: i18n.t('common.confirm_before_cancel'),
                btnConfig: [
                    {
                        text: 'cancel',
                        cssClass: 'outlined info',
                    },
                    {
                        text: 'ok',
                        cssClass: 'danger',
                    },
                ],
            });
            if (isConfirmOk) {
                goToMainPage();
            }
        };
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_form = _resolveComponent("v-form");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_form, {
                    ref_key: "formRef",
                    ref: formRef,
                    modelValue: formValid.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formValid).value = $event)),
                    class: "create-rider-wrapper",
                    onSubmit: _withModifiers(handleSubmitForm, ["prevent"])
                }, {
                    default: _withCtx(() => [
                        _createCommentVNode(" 근무 정보 "),
                        _createVNode(WorkInfo, {
                            lc: lc,
                            "form-rules-lc": formRulesLc,
                            "form-rules": _unref(formRules),
                            "form-data": formData,
                            "error-message-data": errorMessageData,
                            onSetFormData: setFormData,
                            onSetErrorMessageData: _unref(setErrorMessageData)
                        }, null, 8 /* PROPS */, ["form-rules", "form-data", "error-message-data", "onSetErrorMessageData"]),
                        _createCommentVNode(" 차량면허 및 보험 정보 "),
                        _createVNode(PrivateInfo, {
                            lc: lc,
                            "form-rules": _unref(formRules),
                            "form-data": formData,
                            onSetFormData: setFormData
                        }, null, 8 /* PROPS */, ["form-rules", "form-data"]),
                        _createCommentVNode(" 배송 설정 "),
                        _createVNode(DeliverySetting, {
                            lc: lc,
                            "form-rules": _unref(formRules),
                            "form-data": formData,
                            onSetFormData: setFormData
                        }, null, 8 /* PROPS */, ["form-rules", "form-data"]),
                        _createElementVNode("div", _hoisted_2, [
                            _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                class: "mr-2",
                                onClick: handleClickCancelForm
                            }, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                    _createTextVNode(" 취소 ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [1]
                            })), [
                                [
                                    _directive_btn_style,
                                    void 0,
                                    "config",
                                    {
                                        info: true,
                                        outlined: true,
                                        "width-xs": true,
                                        "size-l": true
                                    }
                                ]
                            ]),
                            _withDirectives((_openBlock(), _createBlock(_component_v_btn, { type: "submit" }, {
                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                    _createTextVNode(" 등록 ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [2]
                            })), [
                                [
                                    _directive_btn_style,
                                    void 0,
                                    "config",
                                    {
                                        primary: true,
                                        "width-xs": true,
                                        "size-l": true
                                    }
                                ]
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ]));
        };
    }
});
